import { render, staticRenderFns } from "./SupplierAccount.vue?vue&type=template&id=728930a4"
import script from "./SupplierAccount.vue?vue&type=script&lang=js"
export * from "./SupplierAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports